import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsEquipmentStatus, PmsEquipmentStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsEquipmentStatus>
    useData={usePmsEquipmentStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
